/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 12:11:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 12:30:27
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/slice/index.ts
 */
import { combineReducers } from '@reduxjs/toolkit';
// import legalEditor from '../LegalPageEditor/slice';
// import termsAndConditionEditor from '../TermsAndConditionEditor/slice';
import ProductCategory from '../ProductCategory/slice';
import LegalCategory from '../PagesCategory/LegalCategory/slice';
import ContentCategory from '../PagesCategory/ContentCategory/slice';

import { EnumReducers } from './constants';
export { EnumReducers };
const salesChannelCategory = combineReducers({
  [EnumReducers.products]: ProductCategory,
  [EnumReducers.legal]: LegalCategory,
  [EnumReducers.content]: ContentCategory,
  // legalEditor,
  // termsAndConditionEditor,
});

export default salesChannelCategory;
